// seedScorePages/SharedForms/SharedProgressBar.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProgressBar.css';

// NOTE: route'lar aynı kalıyor, yalnızca label'ları i18n ile alıyoruz
const stepsConfig = [
  { id: 1, route: '/entrepreneur-info', key: 'steps.entrepreneurInfo' },
  { id: 2, route: '/financial-table', key: 'steps.financialTable' },
  { id: 3, route: '/assessment', key: 'steps.assessment' },
  // Eğer dashboard/report gibi 4. adım olacaksa şu şekilde ekleyebilirsiniz:
  // { id: 4, route: '/dashboard', key: 'steps.dashboard' },
];

const ProgressBar = ({ currentStep: propCurrentStep }) => {
  const location = useLocation();
  const { t } = useTranslation();

  // route bazlı step tespiti
  const getCurrentStepFromRoute = () => {
    const currentRoute = location.pathname;

    if (currentRoute.includes('/entrepreneur-info')) return 1;
    if (currentRoute.includes('/financial-table')) return 2;
    if (currentRoute.includes('/assessment')) return 3;
    if (currentRoute.includes('/dashboard') || currentRoute.includes('/report')) return 4;

    return 1;
  };

  const currentStep = propCurrentStep || getCurrentStepFromRoute();

  return (
    <div className="progress-container">
      {stepsConfig.map((step, index) => {
        const isActive = currentStep === step.id;
        const isCompleted = currentStep > step.id;
        const isConnectorActive = currentStep > step.id;

        // i18n ile label al (fallback: key adını göster)
        const label = t(`progress.${step.key}`, { defaultValue: t(step.key) }) || t(step.key) || step.key;

        return (
          <React.Fragment key={step.id}>
            <div className={`step-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
              <div className={`step-circle ${isCompleted ? 'completed' : isActive ? 'active' : ''}`}>
                {isCompleted ? '✓' : step.id}
              </div>
              <div className="step-label">{label}</div>

              {index < stepsConfig.length - 1 && (
                <div className={`step-connector ${isConnectorActive ? 'active' : ''}`}></div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ProgressBar;
